import { object, string } from "yup";
import { nonEmptyRequiredString, practitioner } from "../shared.js";
import { disclosureHarmfulSchema, soadAssessmentCompletionStatusSchema, } from "./helpers.js";
import { exampleSRFData } from "./srf.js";
const patientCapability = string()
    .oneOf(["not-capable", "not-consented"])
    .default(null)
    .required("Please confirm the correct option");
export const soadT3Part1DataSchema = object({
    practitioner: practitioner(),
    patientCapability,
    treatment: nonEmptyRequiredString.required("Please include a description of treatment or plan of treatment"),
    reasons: nonEmptyRequiredString.required("Please include your reasons"),
    disclosureHarmful: disclosureHarmfulSchema,
    completionStatus: soadAssessmentCompletionStatusSchema,
});
// Example data
const patient = {
    name: "John Doe",
    address: "123 address",
    postalCode: "SE4",
    dateOfBirth: null,
};
const user = {
    name: "Dr Bob",
    email: "bob@bob.com",
    address: "123 hospital",
    postalCode: "SE5",
    isGuest: false,
    isConfirmed: true,
};
export const exampleSoadT3Data = [
    {
        data: {
            practitioner: user,
            patientCapability: "not-capable",
            treatment: "TREATMENT",
            reasons: "REASONS",
            disclosureHarmful: false,
            completionStatus: "completed",
        },
        context: {
            patient,
            user,
            formContext: { officialReferenceId: "1233445" },
            srfData: exampleSRFData.map(({ data }) => data),
        },
    },
];
//# sourceMappingURL=soad-t3.js.map